/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer, VApplication } from '../../../../../application';
import { ApplicationDetailPageService } from '../../../services';
import { toast } from 'react-hot-toast';

const MODULE_NAME = 'renewCSMECertificate.machines.states.getPage';

const getSrv = () => {
  return vappContainer.get<ApplicationDetailPageService>(
    ApplicationDetailPageService.displayName
  );
};

export const renewCSMECertificate = async (context: any, event: any) => {
  console.log(`in renewCSMECertificate state :`, event);
  return new Promise(async (resolve, reject) => {
    try {
      console.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const src = getSrv();

      const data: any = await src.agent.renewCSMECertificate(event?.payload);
      console.log(`payload in renewCSMECertificate ::::`, event?.payload, data);
      if (data) {
        // toast.success(context['CREATE_APPLICATION_SUCCESS'].message);
        return resolve({
          key: 'CREATE_APPLICATION_SUCCESS',
          value: {
            ...(data || {}),
          },
        });
      } else {
        // toast.error(context['CREATE_APPLICATION_ERROR']?.message);
        return reject({
          key: 'CREATE_APPLICATION_ERROR',
          value: 'Failed to submit application',
        });
      }
    } catch (err: any) {
      // toast.error(context['CREATE_APPLICATION_ERROR']?.message);
      return reject({
        key: 'CREATE_APPLICATION_ERROR',
        value: err?.message,
      });
    }
  });
};
